import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  useTheme,
  alpha,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  Search as SearchIcon,
  PersonAdd as PersonAddIcon,
  AutoAwesome as AutoAwesomeIcon,
  Dashboard as DashboardIcon,
  Work as WorkIcon,
  ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";
import SupportLayout from "../Support/SupportLayout";

const ServicesOverview = () => {
  const theme = useTheme();

  const services = [
    {
      icon: <SearchIcon sx={{ fontSize: 48 }} />,
      title: "Find a Cleaner",
      description: "Connect with trusted local cleaners for turnovers and recurring needs.",
      link: "/services/find-cleaner",
      color: "#3b82f6",
    },
    {
      icon: <PersonAddIcon sx={{ fontSize: 48 }} />,
      title: "Bring Your Cleaner",
      description: "Invite your existing cleaner and manage everything in one place.",
      link: "/services/bring-cleaner",
      color: "#10b981",
    },
    {
      icon: <AutoAwesomeIcon sx={{ fontSize: 48 }} />,
      title: "Automate Turnovers",
      description: "Auto-create jobs from bookings and prevent missed cleanings.",
      link: "/services/automate-turnovers",
      color: "#8b5cf6",
    },
    {
      icon: <DashboardIcon sx={{ fontSize: 48 }} />,
      title: "Manage Properties",
      description: "Track all your properties from a single dashboard.",
      link: "/services/manage-properties",
      color: "#f59e0b",
    },
    {
      icon: <WorkIcon sx={{ fontSize: 48 }} />,
      title: "Cleaner Jobs",
      description: "Find more cleaning jobs and build repeat clients.",
      link: "/services/cleaner-jobs",
      color: "#ef4444",
    },
  ];

  return (
    <SupportLayout
      title="Services for Hosts & Cleaners"
      category="Our Services"
      subtitle="Everything you need to manage cleanings, find cleaners, and grow your business"
      breadcrumbs={[{ label: "Services" }]}
    >
      <Grid container spacing={4}>
        {services.map((service, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <Card
              component={Link}
              to={service.link}
              sx={{
                height: "100%",
                p: 3,
                borderRadius: 3,
                textDecoration: "none",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: theme.shadows[8],
                },
              }}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: "16px",
                  bgcolor: alpha(service.color, 0.1),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 2,
                  color: service.color,
                }}
              >
                {service.icon}
              </Box>
              <Typography variant="h6" fontWeight="700" gutterBottom>
                {service.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {service.description}
              </Typography>
              <Button
                endIcon={<ArrowForwardIcon />}
                sx={{ color: service.color, fontWeight: 600 }}
              >
                Learn More
              </Button>
            </Card>
          </Grid>
        ))}
      </Grid>
    </SupportLayout>
  );
};

export default ServicesOverview;